import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    const handleClickOutside = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-324" data-mp="2wb5v8yq2www4">
      <div ref={modalRef} className="relative bg-white rounded-xl shadow-xl w-full max-w-md mx-auto overflow-hidden" data-id="element-325" data-mp="2rcumkrbissfh">
        <button onClick={onClose} className="absolute top-2 right-2 z-10 p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors" aria-label="Close modal" data-id="element-326" data-mp="2hcllp06l2itr">
          <XIcon className="w-4 h-4 text-gray-600" data-id="element-327" data-mp="3ezkirc16tss6" />
        </button>
        <div className="px-6 py-5" data-id="element-328" data-mp="3a2anvgv14owy">{children}</div>
      </div>
    </div>;
};